



















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setSelect, focusNext } from "@/service/util";
@Component
export default class InputCode extends Vue {
  @Prop() maxlength: number;
  @Prop() index: number;
  @Prop() value: number;
  @Prop() readonly: any;
  @Prop() disabled: any;
  @Prop() className: string;
  @Prop() styleInput: string;

  public displayValue: string = "";
  timerSelect: any = null;

  $refs!: {
    input: HTMLElement;
  };

  @Watch("value")
  onValueChange(value: any, oldVal: any) {
    this.initValue(value);
  }

  created() {
    this.initValue(this.value);
  }

  initValue(value: any) {
    if (value != undefined) {
      this.value = value;
      this.displayValue = this.value.toString();
      this.numberToText();
      this.setCurrentValue();
    }
  }

  numberToText() {
    this.displayValue = this.displayValue.toString();
  }

  onInput() {
    if (this.displayValue) {
      this.setCurrentValue();
    }
  }

  setCurrentValue() {
    const str = this.displayValue.replace(/,/g, "");
  }

  clearTimerSelect() {
    if (this.timerSelect) {
      clearTimeout(this.timerSelect);
      this.timerSelect = null;
    }
  }

  onEnter() {
    this.clearTimerSelect();
    focusNext(this.index);
  }

  onFocus() {
    this.clearTimerSelect();
    if (!this.readonly) {
      const element: HTMLInputElement = this.$el as HTMLInputElement;
      this.timerSelect = setTimeout(() => {
        setSelect(element);
      }, 200);
    }
  }

  onBlur() {
    this.clearTimerSelect();
    this.numberToText();
    this.$emit("input", this.displayValue);
    this.$emit("focusout", this.displayValue);
  }

  getValue() {
    return this.displayValue;
  }

  focus() {
    this.$refs.input.focus();
  }

  onChange(val: any) {
    this.$emit("change", this.displayValue);
  }
}
